<template>
    <div>
        <div v-if="!editing" :class="reactiveClass">
            <b-link title="Cliquer pour modifier" @click="edit">
                {{ initials }}
            </b-link>
        </div>
        <div v-if="editing">
            <b-input-group>
                <b-input-group-prepend>
                    <b-button title="Annuler" size="sm" @click="display">
                        <i class="fas fa-fw fa-times"></i>
                    </b-button>
                </b-input-group-prepend>
                <b-select
                    v-model="form.accounting_firm_user_id"
                    size="sm"
                    :options="options"
                    @change="update"
                />
            </b-input-group>
        </div>
    </div>
</template>

<script>
import TableFormHandler from '../../../common/mixins/TableFormHandler'

export default {
    name: 'TableRoleHandler',

    mixins: [TableFormHandler],

    props: {
        roleAssignment: null,
    },

    data() {
        return {
            editing: false,
            initials: '',
            form: {},
            options: [],
        }
    },

    async created() {
        this.init()
    },

    methods: {
        init() {
            this.initials = this.roleAssignment.initials
            this.form.accounting_firm_user_id =
                this.roleAssignment.accounting_firm_user_id
        },

        async edit() {
            await this.getOptions()
            this.editing = true
        },

        display() {
            this.editing = false
        },

        async getOptions() {
            try {
                const response = await axios.get(
                    `/collaboratorsFromCompany/${this.roleAssignment.accounting_firm_company_id}/initials`
                )
                this.options = response.data.data
            } catch (error) {
                console.log(error)
            }
        },

        async update() {
            try {
                await axios.put(
                    `/roleAssignments/${this.roleAssignment.id}`,
                    this.form
                )
                this.handleSuccess()
                this.setInitials()
                this.display()
            } catch (error) {
                this.initForm()
                this.display()
                this.handleError()
                console.log(error)
            }
        },

        setInitials() {
            const selectedOption = this.options.find(
                (item) => item.value === this.form.accounting_firm_user_id
            )
            this.initials = selectedOption.text
        },
    },
}
</script>

<style scoped></style>
